import axios from 'axios';
import httpResponseCodeService from '@/services/shared/httpResponseCodeService.js';

const headers = {
  'Content-Type': 'application/json'
};

export default {
  post: function (url, body) {
    return new Promise(function (resolve) {
      axios({
        method: 'post',
        url: url,
        withCredentials: true,
        headers,
        data: body
      }).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          response.ok = false;
          resolve(response);
        }
      }).catch(e => {
        const response = {
          ok: false,
          message: httpResponseCodeService.getResponseCodeMessage(e.status)
        };
        resolve(response);
      });
    });
  }
};
